/**
 *
 * AdministratorBCFormDialog
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AdvancedFormDialog from 'containers/AdvancedFormDialog';
import {TENANT_RULE_FORM, TENANT_RULE_FORM_DIALOG} from "./constants";


export function TenantFormDialog({form, viewName}) {
    return (
        <AdvancedFormDialog
            name={TENANT_RULE_FORM_DIALOG}
            formName={TENANT_RULE_FORM}
            advancedForm={form}
            viewModeTitle="Просмотр документа"
            viewName={viewName}
        />
    );
}

TenantFormDialog.propTypes = {
    form: PropTypes.node.isRequired,
    viewName: PropTypes.string,
};

